export default "/signup/_next/static/chunks/fonts/inter-v3-latin-500-b731904b34eac42c0de5bd4b422efdd3.woff";